import React,{useCallback}  from 'react'//,{useState,useCallback}
import styles from './CallsSettings.module.css'
// import { DropdownButton, Dropdown, Button } from 'react-bootstrap'
// import * as loginReq from '../../../../axios/requests/loginReq'
import {useTranslation} from "react-i18next";
import SettingsDropDown from '../../../UI/SettingsDropDown/SettingsDropDown'


const CallsSettings = (props) => {
    const [t] = useTranslation('common')
    const setSettings = props.setSettings
    const setSaveAndRestartBtnActiveState=props.setSaveAndRestartBtnActiveState
    const setSettingsMiddleware = useCallback((settingType, settingName, value) => {
        setSettings(settingType, settingName, value)
        setSaveAndRestartBtnActiveState(true)
    }, [setSettings,setSaveAndRestartBtnActiveState])
    const autoDialList=[true,false]
    const incomingCall_enableList=[true,false]
    const incomingCall_onAnswer=[true,false]
    return (
        <section className={styles.SettingsSection}>
                <h2 className={styles.settingsTitle}>{t('dialSettings')}</h2>
                <SettingsDropDown nowSelected={props.callssetting.autoDial} setSettings={setSettingsMiddleware} settingType={'calls'} label={'autoDial'}  settingName={'autoDial'} items={autoDialList} />
                <SettingsDropDown nowSelected={props.callssetting.popUpCrmWindow.incomingCall_enable} setSettings={setSettingsMiddleware} settingType={'calls'} label={'incomingCall_enable'}  settingName={'incomingCall_enable'} items={incomingCall_enableList} />
                <SettingsDropDown nowSelected={props.callssetting.popUpCrmWindow.incomingCall_onAnswer} setSettings={setSettingsMiddleware} settingType={'calls'} label={'incomingCall_onAnswer'}  settingName={'incomingCall_onAnswer'} items={incomingCall_onAnswer} />
        </section >
    )
}

export default CallsSettings
